import React, { createContext, useContext, useState, useEffect } from "react";

// Create the context
const RouteBaseStateContext = createContext();

export const useRouteBaseStateContext = () => {
  const context = useContext(RouteBaseStateContext);
  if (!context) {
    throw new Error(
      "useRouteBaseStateContext must be used within RouteBaseStateProvider"
    );
  }
  return context;
};

// Helper function to encode and decode data
const encodeData = (data) => btoa(JSON.stringify(data));
const decodeData = (encodedData) => {
  try {
    return JSON.parse(atob(encodedData));
  } catch (e) {
    return null;
  }
};

export const RouteBaseStateProvider = ({ children }) => {
  // Decode the state from localStorage if it exists, else use default state
  const initialState = decodeData(localStorage.getItem("urlState")) || {
    manageworkprojetroute: "",
    manageworkjobroute: "",
    manageworkcontestroute: "",
    myorderroute: "",
    receivedorderroute: "",
    receivedorderrouterequest: "",
    receivedorderrouteactive: "",
    myorderPostedordersroute: "",
    myorderPurchasedordersroute: "",
    myorderCompletedroute: "",
    myorderrecentprojectroute: "",
    myorderactiveprojectroute: "",
    myallprojectlistroute: "",
    myallconstestlistroute: "",
    myalljoblistroute: "",
    manageappliedprojectroute: "",
    manageactivecontestroute: "",
    myorderrecentjobsroute: "",
    myorderactivejobsroute: "",
    manageappliedjobroute: "",
    teamroute: "",
    teammember: "",
    myots: "",
    myotsAutoOpen: false,
    canderroute: "",
  };

  const [urlstate, setUrlState] = useState(initialState);

  // Save the encoded state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("urlState", encodeData(urlstate));
  }, [urlstate]);

  const setStateAsync = (newState) =>
    new Promise((resolve) => {
      setUrlState((prevState) => {
        const updatedState = { ...prevState, ...newState };
        resolve(updatedState);
        return updatedState;
      });
    });

  const setManageworkProjeteroute = async (value) =>
    await setStateAsync({ manageworkprojetroute: value });
  const setManageworkJobroute = async (value) =>
    await setStateAsync({ manageworkjobroute: value });
  const setManageworkContestroute = async (value) =>
    await setStateAsync({ manageworkcontestroute: value });
  const setMyOrderroute = async (value) =>
    await setStateAsync({ myorderroute: value });
  const setReceivedOrderroute = async (value) =>
    await setStateAsync({ receivedorderroute: value });
  const setReceivedOrderRequestroute = async (value) =>
    await setStateAsync({ receivedorderrouterequest: value });
  const setReceivedOrderActiveroute = async (value) =>
    await setStateAsync({ receivedorderrouteactive: value });
  const setMyorderPostedordersroute = async (value) =>
    await setStateAsync({ myorderPostedordersroute: value });
  const setMyorderPurchasedordersroute = async (value) =>
    await setStateAsync({ myorderPurchasedordersroute: value });
  const setMyorderCompletedroute = async (value) =>
    await setStateAsync({ myorderCompletedroute: value });
  const setMyorderRecentprojectroute = async (value) =>
    await setStateAsync({ myorderrecentprojectroute: value });
  const setMyorderActiveprojectroute = async (value) =>
    await setStateAsync({ myorderactiveprojectroute: value });
  const setMyAllProjectListroute = async (value) =>
    await setStateAsync({ myallprojectlistroute: value });
  const setMyAllContestListroute = async (value) =>
    await setStateAsync({ myallconstestlistroute: value });
  const setMyAllJobListroute = async (value) =>
    await setStateAsync({ myalljoblistroute: value });
  const setManageAppliedprojectroute = async (value) =>
    await setStateAsync({ manageappliedprojectroute: value });
  const setManageActivecontestroute = async (value) =>
    await setStateAsync({ manageactivecontestroute: value });
  const setMyorderRecentjobsroute = async (value) =>
    await setStateAsync({ myorderrecentjobsroute: value });
  const setMyorderActivejobsroute = async (value) =>
    await setStateAsync({ myorderactivejobsroute: value });
  const setManageAppliedjobroute = async (value) =>
    await setStateAsync({ manageappliedjobroute: value });
  const setCalenderroute = async (value) =>
    await setStateAsync({ canderroute: value });
  const setTeamroute = async (value) =>
    await setStateAsync({ teamroute: value });
  const setTeamMemberroute = async (value) =>
    await setStateAsync({ teammember: value });
  const setOTSroute = async (value) => await setStateAsync({ myots: value });
  const setOTSAutoOpen = async (value) => await setStateAsync({ myotsAutoOpen: value });

  const resetAllFields = async () =>
    await setStateAsync({
      manageworkprojetroute: "",
      manageworkjobroute: "",
      manageworkcontestroute: "",
      myorderroute: "",
      receivedorderroute: "",
      receivedorderrouterequest: "",
      receivedorderrouteactive: "",
      myorderPostedordersroute: "",
      myorderPurchasedordersroute: "",
      myorderCompletedroute: "",
      myorderrecentprojectroute: "",
      myorderactiveprojectroute: "",
      myallprojectlistroute: "",
      myallconstestlistroute: "",
      myalljoblistroute: "",
      manageappliedprojectroute: "",
      manageactivecontestroute: "",
      myorderrecentjobsroute: "",
      myorderactivejobsroute: "",
      manageappliedjobroute: "",
      teamroute: "",
      myots: "",
      myotsAutoOpen: false,
      canderroute: "",
    });

  return (
    <RouteBaseStateContext.Provider
      value={{
        urlstate,
        setOTSroute,
        setOTSAutoOpen,
        setTeamMemberroute,
        setTeamroute,
        setManageAppliedjobroute,
        setMyorderActivejobsroute,
        setMyorderRecentjobsroute,
        setManageActivecontestroute,
        setManageAppliedprojectroute,
        setMyorderActiveprojectroute,
        setMyAllProjectListroute,
        setMyAllContestListroute,
        setMyAllJobListroute,
        setMyorderRecentprojectroute,
        setMyorderPostedordersroute,
        setMyorderPurchasedordersroute,
        setMyorderCompletedroute,
        setMyOrderroute,
        setReceivedOrderroute,
        setReceivedOrderRequestroute,
        setReceivedOrderActiveroute,
        setManageworkProjeteroute,
        setManageworkJobroute,
        setManageworkContestroute,
        setCalenderroute,
        resetAllFields,
      }}
    >
      {children}
    </RouteBaseStateContext.Provider>
  );
};
